declare global {
  interface Window {
    TURNSTILE_SITE_KEY: string;
  }
}
export const TURNSTILE_SITE_KEY = window.TURNSTILE_SITE_KEY;
